































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import ShiftDto from '@/models/Shifts/ShiftDto';
import SelectableEntity from '@/models/Shared/SelectableEntity'
import ShiftStatus from '@/components/Shifts/Display/ShiftStatus.vue';
import ShiftStatusEnum from '@/models/Shifts/ShiftStatus';
import CreateBookingRoleWorkerShiftsRequest from '@/models/BookingRoleWorkerShifts/CreateBookingRoleWorkerShiftsRequest';


@Component({
    name: 'BookingManageWorkersAddShifts', 
    components: { ShiftStatus }
})
export default class extends GiganautVueDialog {

  @Prop()
  selectedBookingRole: BookingRoleDto;

  public dialog = false;
  public shifts: SelectableEntity<ShiftDto>[] = [];
  public selectedShiftIds: string[] = [];
  public sendWorkerOfferNotification = false;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.selectedShiftIds = [];

      const availableShifts = BookingDetailsModule.offeredWorkersVM.selectedBookingRole.shifts.filter(function(shift) {
        //Filter out cancelled shifts...
        if(shift.status == ShiftStatusEnum.Cancelled) {
          return false;
        }
        //Do we already have a booking role worker shift for this?
        for (let index = 0; index < BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.bookingRoleWorkerShifts.length; index++) {
          if (BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.bookingRoleWorkerShifts[index].shiftId === shift.id) {
            return false;
          }
        }
        return true;
      });
      this.shifts = availableShifts.map(function(shift) {
        return new SelectableEntity<ShiftDto>(shift);
      })
    }
  }

  // allShiftsAreBooked() {
  //   var allBooked: boolean = true;
  //   for (let index = 0; index < this.shifts.length; index++) {
  //     const shift = this.shifts[index];
  //     console.log(shift.entity.status);
  //     if (shift.entity.status != this.bookingRoleWorkerShiftStatusEnum.BookedUnconfirmed && shift.entity.status !== this.bookingRoleWorkerShiftStatusEnum.BookedConfirmed) {
  //        allBooked = false;
  //     }
  //   }
  //   return allBooked;
  // }

  get loading() {
    return BookingDetailsModule.loadingDialog;
  }

  get selectedWorker() {
      return BookingDetailsModule.offeredWorkersVM.selectedWorker;
  }

  async updateSelectedShifts(val: boolean, shift: ShiftDto) {
    	if (val) {
			  this.selectedShiftIds.push(shift.id);
		} else {
			  const index = this.selectedShiftIds.indexOf(shift.id);
        this.selectedShiftIds.splice(index, 1); 
		}
	}
	  
  async confirm() { 
    const request = new CreateBookingRoleWorkerShiftsRequest();
    request.bookingRoleWorkerId = BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker.id;
    request.shiftIds = this.selectedShiftIds;
    request.sendWorkerOfferNotification = this.sendWorkerOfferNotification;
    await BookingDetailsModule.createBookingRoleWorkerShifts(request);
    await BookingDetailsModule.updateOfferedSelectedBookingRole(this.selectedBookingRole);
    this.dialog = false;
  }
}
